import React, { useContext, useState } from "react";
import { DataTable, Table } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { FILE_BROWSER_ROUTES } from "../../../constants";
import { expandedRowPaginationUpdated, expandedRowSortUpdated, selectExpandedRowPagination, selectExpandedRowSort, selectFilter, } from "../../../store/issuesSlice";
import { ComponentList } from "../../../ui";
import { generateOverrideId } from "../../../utils";
import { ComponentName, ComponentPriorityAndIssuesLink, PolicyAudit, } from "../../common";
import { ReportContext } from "../../context";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetComponentListQuery } from "../../services/issues.api";
import styles from "./issue.module.scss";
const ComponentRow = ({ rowIndex, component, focused, onClick, }) => {
    const componentSummary = (React.createElement(React.Fragment, null,
        React.createElement(Table.Cell, null,
            React.createElement(ComponentList.PriorityAndIssues, { component: component, id: rowIndex.toString(), badgeWrapper: (target, children) => (React.createElement(ComponentPriorityAndIssuesLink, { htmlId: rowIndex.toString(), componentId: component.id, componentPath: component.path, target: target }, children)) })),
        React.createElement(Table.Cell, null,
            React.createElement(ComponentName, { component: component, id: rowIndex.toString(), fileBrowserPage: FILE_BROWSER_ROUTES.ISSUES_ROUTE })),
        React.createElement(Table.Cell, null,
            React.createElement(ComponentList.Path, { path: component.path }))));
    const hasAudit = component.audit.present;
    return (React.createElement(DataTable.ExpandedRow, { disabled: !hasAudit, focused: focused, onClick: onClick },
        React.createElement(DataTable.ExpandedRow.Summary, null, componentSummary),
        hasAudit && (React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(PolicyAudit, { audit: component.audit })))));
};
export const IssueOverrideComponentList = ({ rowIndex, issueId, override, }) => {
    const { reportId, diffId } = useContext(ReportContext);
    const overrideId = generateOverrideId(override);
    const dispatch = useReportDispatch();
    const issuesFilter = useReportSelector(selectFilter);
    const pagination = useReportSelector((state) => selectExpandedRowPagination(state, issueId, overrideId));
    const sortBy = useReportSelector((state) => selectExpandedRowSort(state, issueId, overrideId));
    const [focused, setFocused] = useState(null);
    const { data = {
        components: [],
        match_count: 0,
    }, isLoading, isFetching, isError, error, } = useGetComponentListQuery({
        diffId,
        enabled: override.enabled,
        status: override.status,
        ui_id: reportId,
        ui_item_id: issueId,
        pagination: pagination,
        sort: sortBy,
        filter: issuesFilter,
    });
    const handleSortChange = (newSort) => {
        dispatch(expandedRowSortUpdated({
            id: issueId,
            overrideId: overrideId,
            sort: newSort,
        }));
    };
    // Don't show components whose override status does not match selected status filter
    if (issuesFilter.status &&
        issuesFilter.status.values.length > 0 &&
        issuesFilter.status.values[0] !== override.status)
        return null;
    return (React.createElement("div", { className: styles["component-list"] },
        React.createElement(ComponentList.Table, { itemId: "issue", rowIndex: rowIndex, title: React.createElement("div", null,
                "Policy ",
                React.createElement("b", null, override.enabled ? "Enabled" : "Disabled"),
                " and configured to ",
                React.createElement("b", null, override.status.toUpperCase()),
                " on",
                " ",
                data.match_count.toLocaleString(),
                " component",
                data.match_count === 1 ? "" : "s"), matchCount: data.match_count, queryStatus: getQueryStatus({
                isLoading,
                isFetching,
                isError,
                error,
                data,
            }), totalCount: data.match_count, pagination: pagination, initialItemCount: 5, onPaginationChange: (newPagination) => dispatch(expandedRowPaginationUpdated({
                id: issueId,
                overrideId: overrideId,
                pagination: newPagination,
            })), columns: [
                { id: "audit", label: "Audit", width: "70px" },
                ...ComponentList.columns({
                    sortBy,
                    rowIndex,
                    onSortChange: handleSortChange,
                }),
            ] }, data === null || data === void 0 ? void 0 : data.components.map((component, index) => {
            var _a, _b;
            return (React.createElement(ComponentRow, { key: (_a = component.id) !== null && _a !== void 0 ? _a : component.path, rowIndex: index, component: component, focused: focused === ((_b = component.id) !== null && _b !== void 0 ? _b : component.path), onClick: () => { var _a; return setFocused((_a = component.id) !== null && _a !== void 0 ? _a : component.path); } }));
        }))));
};
export default IssueOverrideComponentList;
//# sourceMappingURL=IssueOverrideComponentList.js.map